var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGs1Logo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.74,
    height: 61,
    viewBox: "0 0 72.74 61",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Global_x5F_Office"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M71.74 37.557v-1.932h-3.574V20.939h-1.738l-4.735 1.932.483 2.125 3.671-1.449v12.077h-4.059v1.932h9.952zm-12.173-7.923c0 15.748-12.85 28.5-28.693 28.5-15.845 0-28.695-12.752-28.695-28.5.096-15.748 12.851-28.5 28.695-28.5s28.693 12.752 28.693 28.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M36.767 21.037c-4.25 0-7.44 3.478-7.44 8.212v.193c0 4.926 2.997 8.212 7.343 8.212 2.415 0 4.252-.967 5.41-1.838v-7.051h-5.507v1.739h3.574v4.154l-.097.097a5.9 5.9 0 0 1-3.187.965c-3.189 0-5.218-2.511-5.218-6.375v-.096c0-3.575 2.126-6.28 5.121-6.28 1.739 0 2.802.579 3.671 1.352l1.258-1.641c-1.548-1.16-2.996-1.643-4.928-1.643m8.405 14.395c1.643 1.447 3.574 2.125 5.604 2.125 3.092 0 5.119-1.837 5.119-4.542 0-2.221-1.158-3.477-4.346-4.636-2.898-1.16-3.672-1.835-3.672-3.188s1.16-2.319 2.803-2.319c1.16 0 2.412.483 3.669 1.449l1.258-1.641c-1.353-1.16-2.996-1.74-4.831-1.74-2.995 0-5.023 1.835-5.023 4.347 0 2.609 1.642 3.672 4.639 4.83 2.605.967 3.477 1.644 3.477 2.998 0 1.448-1.257 2.511-2.994 2.511-1.933 0-3.381-.967-4.348-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M52.806 6.062a2.8 2.8 0 0 1 2.801-2.802 2.804 2.804 0 0 1 2.801 2.802 2.802 2.802 0 0 1-5.602 0m5.022 0a2.19 2.19 0 0 0-2.222-2.223c-1.258 0-2.223.966-2.223 2.223 0 1.255.965 2.222 2.223 2.222a2.187 2.187 0 0 0 2.222-2.222m-3.286-1.354h1.257c.579 0 1.062.29 1.062.87q0 .58-.579.87l.675.966h-.771l-.579-.869h-.387v.869h-.678zm1.257 1.257c.291 0 .483-.193.483-.387s-.192-.387-.483-.387h-.579v.773z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M8.072 29.634c0-13.042 10.048-23.669 22.899-24.732v-.097c-13.817 0-25.024 11.11-25.024 24.829s11.207 24.83 24.927 24.83v-.096C18.12 53.304 8.072 42.58 8.072 29.634"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M13.676 29.634c0-10.917 8.309-19.901 19.032-20.964l-.096-.097c-11.497.193-20.868 9.565-20.868 21.061 0 11.498 9.274 20.87 20.868 21.062l.096-.096c-10.724-1.161-19.032-10.048-19.032-20.966"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M18.99 29.634c0-8.887 6.763-16.23 15.458-17.292l-.097-.097c-9.469.29-17.003 7.922-17.003 17.389 0 9.469 7.534 17.102 17.003 17.391l.097-.098c-8.696-1.062-15.458-8.404-15.458-17.293"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M24.111 29.634A13.6 13.6 0 0 1 36.187 16.11v-.097c-7.439.193-13.332 6.184-13.332 13.622 0 7.439 5.989 13.43 13.332 13.624v-.099c-6.762-.869-12.076-6.568-12.076-13.526"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M71.74 59.996h1v1h-1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGs1Logo);
export default __webpack_public_path__ + "static/media/gs1-logo.7669bbd96b252a6f065bd27b5f1d7acc.svg";
export { ForwardRef as ReactComponent };